/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { staking } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const STAKING_CREATE = 'staking.create';

queryClient.setMutationDefaults(STAKING_CREATE, {
  mutationFn: staking.create,
  onError: (error) => {
    handleError(error);
  },
});
